export const daysOfWeek = [
    { name: 'wanderManagement.schedulersTab.weekDays.Mon', index: 0 },
    { name: 'wanderManagement.schedulersTab.weekDays.Tue', index: 1 },
    { name: 'wanderManagement.schedulersTab.weekDays.Wed', index: 2 },
    { name: 'wanderManagement.schedulersTab.weekDays.Thu', index: 3 },
    { name: 'wanderManagement.schedulersTab.weekDays.Fri', index: 4 },
    { name: 'wanderManagement.schedulersTab.weekDays.Sat', index: 5 },
    { name: 'wanderManagement.schedulersTab.weekDays.Sun', index: 6 },
];

export const sortByTime = function(a, b) {
    let timeA = a.begin_time.split(':');
    let timeB = b.begin_time.split(':');
    let minutesA = Number(timeA[0]) * 60 + Number(timeA[1]);
    let minutesB = Number(timeB[0]) * 60 + Number(timeB[1]);
    return minutesB > minutesA ? -1 : 1;
};

export const toMinutes = function(str) {
    if (!str) {
        return 0;
    }
    let minutes = str.split(':');
    return minutes.length > 1 ? minutes[0] * 60 + Number(minutes[1]) : 0;
};
